export const configurationAlreadyExistsKey = '_KeyCombinationViolation';

export enum formFields {
  subscriberGroup = 'subscriberGroup',
  caseType = 'caseType',
  criteria = 'criteria',
  operation = 'operation'
}
